import "@/app/globals.css";
import "react-day-picker/style.css";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Suspense, useEffect } from "react";
import FullScreenLoader from "@/app/components/full-screen-loader";
import { VersionCheckProvider } from "@/app/components/version-advice";
import { AppToaster } from "@/app/components/e2e-toaster";
import { useLastPage } from "@/hooks/use-last-page";
import { useLocaleSync } from "@/hooks/use-locale-sync";
import { markAppHydrated } from "@/lib/e2e-readiness";
import { QueryProvider } from "@/lib/providers/query-provider";
import { useAppStore } from "@/lib/store/app";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <RootContent />
    </Suspense>
  );
}

function RootContent() {
  useLastPage();
  useLocaleSync();
  const isLanguageLoading = useAppStore((state) => state.isLanguageLoading);

  useEffect(() => markAppHydrated(), []);

  return (
    <VersionCheckProvider>
      <QueryProvider>
        {isLanguageLoading && <FullScreenLoader className="bg-white/100" />}
        <AppToaster />
        <Outlet />
      </QueryProvider>
    </VersionCheckProvider>
  );
}

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-full">
      <h2 className="text-xl font-semibold">Not Found</h2>
      <p className="text-sm">Could not find the requested resource</p>
    </div>
  );
}
